import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import PaddedContentArea from "../../common/PaddedContentArea";
import ChallengeFilters from "./components/ChallengeFilters";
import ChallengeCards from "./components/ChallengeCards";
import { GetChallenges, GetMyChallenges, EmptyChallenges, } from "../../redux/v2/challenge/actions";
import { GetAllWorkOutHistories, GetSelectionHistory } from "../../redux/v2/user/actions";

import "./style.css"
import { useMediaQuery } from '@mui/material'
import { ScreenType } from "../../utils/breakpoints";


function Challenge(props) {
    const challengeID = new URLSearchParams(window.location.search).get("challenge");
    const challengeType = new URLSearchParams(window.location.search).get("challenge-type");

    const { state } = useLocation();
    const [status, setStatus] = useState(challengeType ? challengeType : "active");
    const [challengeProp, setChallengeProp] = useState(null);
    const screenSize = ScreenType(useMediaQuery);

    useEffect(async () => {
        if (challengeID && props.Challenge?.challenges?.length) {
            let cha;
            cha = props.Challenge?.challenges.filter(mc => mc.id == challengeID);

            cha = {
                ...cha[0],
            }

            setStatus(cha?.statusType || "active");
            setChallengeProp(cha);
        }

    }, [challengeID, props.Challenge?.challenges?.length]);

    useEffect(() => {
        if (state?.challengeProp) {
            setStatus(state?.challengeProp?.statusType || "active");
        }
    }, [state?.challengeProp]);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        })
        props.GetMyChallenges();
        props.GetAllWorkOutHistories();
        props.GetSelectionHistory();
    }, []);

    useEffect(() => {

        props.EmptyChallenges();
        props.GetChallenges(status);
    }, [status]);

    return (
        <div id="challenge-page" className="flex-c content-area">
            <PaddedContentArea>
                <div id="challenge-wrapper" style={{ maxWidth: screenSize == "xl" ? "859px" : "600px" }}>
                    <ChallengeFilters setStatus={setStatus} status={status} />
                    <ChallengeCards screenSize={screenSize} challenges={props.Challenge.challenges} status={status} selected={challengeProp} />
                </div>
            </PaddedContentArea>
        </div>
    );
}

const mapStateToProps = (state) => ({
    Challenge: state.Challenge
});

export default connect(mapStateToProps, {
    GetChallenges,
    EmptyChallenges,
    GetMyChallenges,
    GetAllWorkOutHistories,
    GetSelectionHistory,
})(Challenge);